import { useReactiveVar } from '@apollo/client'
import React from 'react'

import { FONT_SIZES } from '../constants/theme'
import { fontSizeVar } from '../graphql/cache'
import { hasOwnProp } from '../lib/object'
import { setFontSize } from '../lib/storage'
import { useI18n } from '../../configuration/contexts/I18nContext'

export const useFontSizeToggle = () => {
  const i18n = useI18n()
  const fontSize = useReactiveVar(fontSizeVar)
  let fontSizeTitle = i18n.t('fontSizes.increaseFontSize')
  const numFontSize = Number(fontSize)
  const nextFontSize =
    numFontSize === FONT_SIZES.length - 1 ? 0 : numFontSize + 1
  const nextFontTitle = FONT_SIZES[nextFontSize].label.toLowerCase()
  const translatedFontSize = i18n.t(`fontSizes.${nextFontTitle}`)
  fontSizeTitle += ` ${translatedFontSize}`

  const handleToggleFontSize = React.useCallback(
    (size: { 'local.fontSize': number } | React.MouseEvent<HTMLElement>) => {
      const newSize = hasOwnProp(size, 'local.fontSize')
        ? parseInt(size['local.fontSize'], 10)
        : fontSizeVar() + 1
      const htmlTag = document.querySelector('html')
      if (!htmlTag) {
        return
      }
      const fontSize = newSize >= FONT_SIZES.length ? 0 : newSize
      htmlTag.style.fontSize = FONT_SIZES[fontSize]?.size
      setFontSize(fontSize)
      fontSizeVar(fontSize)
    },
    [],
  )

  return {
    fontSizeTitle,
    fontSize,
    handleToggleFontSize,
  }
}
